var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-full",
    [
      _c("router-view"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-1", attrs: { slot: "navbar" }, slot: "navbar" },
        [
          _c("ul", { staticClass: "nav navbar-nav d-xl-none" }, [
            _c(
              "li",
              { staticClass: "nav-item" },
              [
                _c(
                  "b-link",
                  {
                    staticClass: "nav-link",
                    on: { click: _vm.toggleVerticalMenuActive },
                  },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "MenuIcon", size: "21" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v("I am in navbar, Everything else is removed"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "p-1",
        attrs: { slot: "breadcrumb" },
        slot: "breadcrumb",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }